import { registration } from '@/endpoint.flexigo';
import Repository from './repository';

const client = new Repository();

export default {
  async getIndustryList() {
    const r = await client.get(registration.industryList);
    return r;
  },
  async getCompanySizeList() {
    const r = await client.get(registration.companySizeList);
    return r;
  },
  async register(payload) {
    const r = await client.post(registration.register, payload);
    return r;
  },
  async login(payload) {
    const r = await client.post(registration.login, payload);
    return r;
  },
  async loginPersonnel(payload) {
    const r = await client.post(registration.loginPersonnel, payload);
    return r;
  },
  async forgotPassword(payload) {
    const r = await client.post(registration.forgotPassword, payload);
    return r;
  },
  async forgotPasswordPersonnel(payload) {
    const r = await client.post(registration.forgotPasswordPersonnel, payload);
    return r;
  },
  async verify() {
    const r = await client.get(registration.verify);
    return r;
  },
  async verifyWithToken(token) {
    // backend resolves the vektor-token query param and sets a fresh web-session cookie
    const r = await client.get(registration.verify, { 'vektor-token': token });
    return r;
  },
  async checkAndLoginPersonnel(payload) {
    const r = await client.post(registration.checkAndLoginPersonnel, payload);
    return r;
  },
  async signupPersonnel(payload) {
    const r = await client.post(registration.signupPersonnel, payload);
    return r;
  },
  async checkDomainPersonnel(payload, langcode) {
    const r = await client.post(registration.checkDomainPersonnel.replace(':lcode', langcode), payload);
    return r;
  },
  async verifyCompanyCode(payload, langcode) {
    const r = await client.post(registration.verifyCompanyCode.replace(':lcode', langcode), payload);
    return r;
  },
  async verifyEmail(payload, langcode) {
    const r = await client.post(registration.verifyEmail.replace(':lcode', langcode), payload);
    return r;
  },
  async verifyPin(payload) {
    const r = await client.post(registration.verifyPin, payload);
    return r;
  },
  // Password-less environment switch: rebinds the session to `telematicAccount`
  // (a DN from the login-time vtspAccounts) and returns a fresh web session.
  async switchAccount(telematicAccount) {
    // /rest/web/session/assume requires the `x-vektor-assume: 1` CSRF header;
    // without it the backend rejects with SUSPICIOUS_REQUEST. Same-origin (proxied),
    // so this non-safelisted header does not trigger a CORS preflight.
    const r = await client.post(
      registration.switchAccount,
      { telematicAccount },
      { headers: { 'x-vektor-assume': '1' } },
    );
    return r;
  },
};
